import React, { Component } from 'react';
import { connect } from 'react-redux';
import LedgerView from './Ledger.view';

import {
  getLedgers,
} from './Ledger.selector';

export class LedgerContainer extends Component {

  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.setViewMode = this.setViewMode.bind(this);
    this.state = {
      viewMode: 'all',
    }
  }

  setViewMode(viewMode) {
    this.setState({
      viewMode,
    });
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_TRANSACTIONS'
    });
  }

  openCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: true,
      }
    });
  }

  render() {
    return (<LedgerView
      {...this.state}
      {...this.props}
      openCreateModal={this.openCreateModal}
      setViewMode={this.setViewMode}
    />);
  }

}

function mapStateToProps(state) {
  return {
    ledgers: getLedgers(state),
  };
}

export default connect(mapStateToProps)(LedgerContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/Ledger.container.js